export default {
    namespaced: true,
    state: {
        showPopup: false,
        showHelperButton: false,
    },
    getters: {
        isHelperOpen: state => state.showPopup,
        isHelperAvailableOnPage: state => state.showHelperButton
    },
    mutations: {
        toggleHelperBlock(state) {
            state.showPopup = !state.showPopup;
        },
        displayHelperButton(state, isDisplayed) {
            state.showHelperButton = isDisplayed;
        },
        hideHelperBlock(state) {
            state.showPopup = false;
        }
    }
}